import { useLocation } from 'react-router-dom';

export const useCustomParam = (param) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return params.get(param);
}